import React from 'react';

const TextLink = ({ children, href, category = 'Page events', label = null, className, target, rel,
    onClick,
    dataEventLocation }) => (
        <a
        href={href}
        className={className}
        data-event-tracking
        data-event-type="click"
        data-event-category={category}
        data-event-label={label ?? children.toString()}
        data-event-location={dataEventLocation}
        target={target}
        rel={rel}
        onClick={onClick}
    >
        {children}
    </a>
);

export default TextLink;
